export enum EventType {
  ANPRDetection = 'ANPRDetection',
  AHCRDetection = 'AHCRDetection',
  CameraStarting = 'CameraStarting',
  CameraStopped = 'CameraStopped',
  CameraRestarting = 'CameraRestarting',
}

export interface CameraEvent {
  cameraId: string
  eventType: string
  timestamp: string
  imageBase64: string
  metadata: Record<string, string>
}
